export default "__VITE_ASSET__DH6Mgkr9__"